import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './DatasetItem.module.css'
import { Button, Divider, Dropdown, Flex, message, Modal, Tooltip } from 'antd'
import classNames from 'classnames'
import userIcon from './userIcon.svg'
import { HTTP_URL } from '../../../../util/constants'
import Cookies from 'js-cookie'
import {
  delDatasets,
} from './BotAndDatasetListApi'
export default function BotItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const deleteDatasetMethod = (key) => {
    if (key == 2) {
      // 更新智能体代码
      alert('暂未实现')
    } else if (key == 3) {
      Modal.confirm({
        title: '确认删除',
        content: '确定要删除这条数据吗？删除后不可恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          delDatasets(
            {
              dataset_id: props.info.dataset_id,
            },
            (res) => {
              if (res.ret == 1) {
                message.success('知识库已删除')
                props.getDatasetList()
              } else {
                message.error(res.msg)
              }
            },
          )
        },
        onCancel() {
          console.log('用户点击了取消')
        },
      })
    }
  }
  return (
    <div className={styles.datasetItemBox}>
      <span style={{ width: "35%" }} className={styles.datasetItem}>
        <img src={props.info.icon_url} className={styles.typeIcon} />
        <Tooltip placement="bottom" title={props.info.name}>
          <p className={styles.datasetItemText}>{props.info.name}</p>
        </Tooltip>
      </span>
      <span style={{ width: "10%" }} className={styles.datasetItem1}>
        {props.info.format_type == 0 ? '文本' : '照片'}
      </span>
      <span style={{ width: "45%" }} className={styles.datasetItem}>
        <Tooltip placement="bottom" title={props.info.description}>
          <p className={styles.datasetItemText}>{props.info.description}</p>
        </Tooltip>
      </span>
      <span style={{ width: "10%" }} className={styles.datasetItem1}>
        <Button
          color="primary"
          variant="outlined"
          onClick={deleteDatasetMethod.bind(null, 3)}
        >
          删除
        </Button>
      </span>
    </div>
  )
}
